import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAttachments = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.7227 7.17031V16.5703C17.7227 19.3317 15.4841 21.5703 12.7227 21.5703V21.5703C9.96123 21.5703 7.72266 19.3317 7.72266 16.5703V7.00781C7.72266 5.10933 9.26168 3.57031 11.1602 3.57031V3.57031C13.0586 3.57031 14.5977 5.10933 14.5977 7.00781V16.6953C14.5977 17.7308 13.7582 18.5703 12.7227 18.5703V18.5703C11.6871 18.5703 10.8477 17.7308 10.8477 16.6953V7.17031",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAttachments;
